import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MyProfileComponent } from "./main-shared/components/my-profile/my-profile.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { Role } from './main-shared/class-models/role-model';
import { AccessDeniedComponent } from "./access-denied/access-denied.component";

const routes: Routes = [
  { path: "my-profile", canActivate: [AuthGuard], component: MyProfileComponent },
  { path: 'customer-admin', canActivate: [AuthGuard], data: { roles: [Role.customerAdmin, Role.masterAdmin, Role.coo, Role.cmo, Role.fieldEngineer], accessLevel: [1, 2, 6] }, loadChildren: () => import('./customer-admin/customer-admin.module').then(m => m.CustomerAdminModule) },
  { path: 'product-admin', canActivate: [AuthGuard], data: { roles: [Role.masterAdmin], accessLevel: [1] }, loadChildren: () => import('./mindtree-admin/mindtree-admin.module').then(m => m.MindtreeAdminModule) },
  { path: 'user-module', canActivate: [AuthGuard], data: { roles: Object.values(Role), accessLevel: [1, 2, 3, 4, 6] }, loadChildren: () => import('./user-module/user-module.module').then(m => m.UserModuleModule) },
  { path: 'product-config', canActivate: [AuthGuard], data: { roles: [Role.masterAdmin, Role.customerAdmin, Role.coo, Role.cmo, Role.fieldEngineer], accessLevel: [1, 2, 6] }, loadChildren: () => import('./product-config-admin/product-config-admin.module').then(m => m.ProductConfigAdminModule) },
  { path: 'main-shared', canActivate: [AuthGuard], data: { roles: Object.values(Role), accessLevel: [1, 2, 3, 4, 6] }, loadChildren: () => import('./main-shared/main-shared.module').then(m => m.MainSharedModule) },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: "", redirectTo: 'main-shared', pathMatch: 'prefix' },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
